import {
  ADD_ALERT,
  ADD_ALERT_ERROR,
  ADD_ALLERGY,
  ADD_ALLERGY_ERROR,
  ADD_RECENTLY_VIEWED_CHART,
  DELETE_ALERT,
  DELETE_ALERT_ERROR,
  DELETE_ALLERGY,
  DELETE_ALLERGY_ERROR,
  EDIT_ALERT,
  EDIT_ALERT_ERROR,
  GET_ALERTS_LIST,
  GET_ALERTS_LIST_ERROR,
  GET_AUDI_LOGS,
  GET_GET_AUDI_LOGS_ERROR,
  GET_INTAKE_FORMS,
  GET_INTAKE_FORMS_ERROR,
  GET_MEDIA_FILES,
  GET_MEDIA_FILES_ERROR,
  GET_PATIENT_CHART_PRINTED_VERSION,
  GET_PATIENT_CHART_PRINTED_VERSION_ERROR,
  GET_PATIENT_INFO,
  GET_PATIENT_INFO_ERROR,
  GET_PATIENT_PAST_VISITS,
  GET_PATIENT_PAST_VISITS_ERROR,
  GET_PATIENT_UPCOMING_VISITS,
  GET_PATIENT_UPCOMING_VISITS_ERROR,
  GET_PATIENTS_LIST,
  GET_PATIENTS_LIST_ERROR,
  GET_PATIENTS_LIST_SUCCESS,
  GET_PRESCRIPTIONS,
  GET_RESCRIPTIONS_ERROR,
  MARK_ALERTS_AS_READ,
  MARK_ALERTS_AS_READ_ERROR,
  SET_ERROR,
  SET_ON_HOLD_STATUS,
  SET_ON_HOLD_STATUS_ERROR,
  SET_PATIENT_HAS_ALLERGIES,
  SET_PATIENT_HAS_ALLERGIES_ERROR,
  SET_PATIENT_HAS_NO_ALLERGIES,
  SET_PATIENT_HAS_NO_ALLERGIES_ERROR,
  SET_PATIENTS_LIST,
  UPDATE_ACCOUNT_INFO,
  UPDATE_ACCOUNT_INFO_ERROR,
  UPDATE_GENERAL_INFO,
  UPDATE_GENERAL_INFO_ERROR,
  UPDATE_VISIT_CREDIT,
  UPDATE_VISIT_CREDIT_ERROR,
  VALIDATE_PHONE_NUMBER,
  VALIDATE_PHONE_NUMBER_ERROR,
} from '../../store/charts/ChartsConstants'

export const chartsBlackList = [
  GET_PATIENTS_LIST,
  GET_PATIENTS_LIST_SUCCESS,
  GET_PATIENTS_LIST_ERROR,
  SET_PATIENTS_LIST,
  GET_PATIENT_INFO,
  GET_PATIENT_INFO_ERROR,
  GET_ALERTS_LIST,
  GET_ALERTS_LIST_ERROR,
  GET_PATIENT_UPCOMING_VISITS,
  GET_PATIENT_UPCOMING_VISITS_ERROR,
  GET_PRESCRIPTIONS,
  GET_RESCRIPTIONS_ERROR,
  GET_AUDI_LOGS,
  GET_GET_AUDI_LOGS_ERROR,
  GET_PATIENT_CHART_PRINTED_VERSION,
  GET_PATIENT_CHART_PRINTED_VERSION_ERROR,
  SET_ERROR,
  GET_PATIENT_PAST_VISITS,
  GET_PATIENT_PAST_VISITS_ERROR,
  GET_MEDIA_FILES,
  GET_MEDIA_FILES_ERROR,
  GET_INTAKE_FORMS,
  GET_INTAKE_FORMS_ERROR,
  EDIT_ALERT,
  EDIT_ALERT_ERROR,
  DELETE_ALERT,
  DELETE_ALERT_ERROR,
  SET_ON_HOLD_STATUS,
  SET_ON_HOLD_STATUS_ERROR,
  SET_PATIENT_HAS_ALLERGIES,
  SET_PATIENT_HAS_ALLERGIES_ERROR,
  SET_PATIENT_HAS_NO_ALLERGIES,
  SET_PATIENT_HAS_NO_ALLERGIES_ERROR,
  ADD_ALLERGY,
  ADD_ALLERGY_ERROR,
  ADD_ALERT,
  ADD_ALERT_ERROR,
  DELETE_ALLERGY,
  DELETE_ALLERGY_ERROR,
  MARK_ALERTS_AS_READ,
  MARK_ALERTS_AS_READ_ERROR,
  UPDATE_ACCOUNT_INFO,
  UPDATE_ACCOUNT_INFO_ERROR,
  UPDATE_GENERAL_INFO,
  UPDATE_GENERAL_INFO_ERROR,
  UPDATE_VISIT_CREDIT,
  UPDATE_VISIT_CREDIT_ERROR,
  VALIDATE_PHONE_NUMBER,
  VALIDATE_PHONE_NUMBER_ERROR,
  ADD_RECENTLY_VIEWED_CHART,
]
